import { useEffect } from 'react';
import { fetchSubscription } from '../../entities/subscription';
import { useAppDispatch, useAppSelector } from '../store';

// Mounted once at the application level; consumers only read the global store.
export function useSubscriptionSync() {
    const dispatch = useAppDispatch();
    const { isAuth, userId } = useAppSelector((state) => state.userAuthSettings);

    useEffect(() => {
        if (!isAuth || !userId) return;

        const refresh = () => {
            if (document.visibilityState === 'visible') {
                void dispatch(fetchSubscription());
            }
        };

        // Also load when authentication completes in a background tab.
        void dispatch(fetchSubscription());
        window.addEventListener('focus', refresh);
        window.addEventListener('online', refresh);
        document.addEventListener('visibilitychange', refresh);

        return () => {
            window.removeEventListener('focus', refresh);
            window.removeEventListener('online', refresh);
            document.removeEventListener('visibilitychange', refresh);
        };
    }, [dispatch, isAuth, userId]);
}
